import React from 'react';
import * as Context from 'fw/system/Context'
import { Form, MaskedBox, IntBox, TextBox, SearchBox, CheckBox } from 'fw/forms';
import { Row, Col, Button, Glyphicon } from 'react-bootstrap'
import { ContentHeader, ContentBody } from 'areas/shared/components';
import queryString from 'query-string';
import {
    CertificationTypeCombo, CertificationStatusCombo, CertificationTrackModeCombo,
    CertificationQueueTypeCombo, CertificationAssigneeCombo, CertificationDaysOpenCombo,
    CertificationDisabledStatusCombo, StateCombo
} from 'areas/shared/controls';
import * as API from 'modules/app/API'
import SearchQueueGrid from './searchQueue/SearchQueueGrid';
import SearchRequestAssociationGrid from './requestAssociation/SearchRequestAssociationGrid';
import SearchRequestAppealGrid from './appealRequested/SearchRequestAppealGrid'
import AssignReviewerUser from './unassignedQueue/AssignReviewerUser';
import * as App from 'modules/app/App'

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.initialState();
    }

    initialState(internalParams) {
        var certificationStatusCode = null;
        var certificationTypeCode = null;
        var certificationDaysOpen = null;
        var disabledVobStatus = null;
        var vobId = null;
        var vobName = "";
        var veteranName = "";
        var vobFEIN = "";
        var queueTypeCode = null;
        var certificationNumber = "";
        var state = null;
        var trackMode = null;
        var assigneeId = null;
        var showAll = null;
        var openOnly = false;
        var flagStatusCode = null;
        var preQualDateFrom = null;
        var preQualDateTo = null;
        var createDateFrom = null;
        var createDateTo = null;
        var submitDateFrom = null;
        var submitDateTo = null;
        var approveDateFrom = null;
        var approveDateTo = null;
        var expirationDateFrom = null;
        var expirationDateTo = null;

        var params = queryString.parse(this.props.location.search);
        if (internalParams != null) {
            certificationStatusCode = internalParams.certificationStatusCode;
            certificationTypeCode = internalParams.certificationTypeCode;
            certificationDaysOpen = internalParams.certificationDaysOpen;
            disabledVobStatus = internalParams.disabledVobStatus;
            }
        else if (Object.keys(params).length !== 0) {
            if (params.p === 'true') {
                var p = App.context().searchQueueFilters;
                queueTypeCode = p.queueTypeCode;
                certificationStatusCode = p.certificationStatusCode;
                certificationTypeCode = p.certificationTypeCode;
                certificationDaysOpen = p.certificationDaysOpen;
                disabledVobStatus = p.disabledVobStatus;
                vobId = p.vobId;
                vobName = p.vobName;
                veteranName = p.veteranName;
                vobFEIN = p.vobFEIN;
                certificationNumber = p.certificationNumber;
                state = p.state;
                assigneeId = p.assigneeId;
                trackMode = p.trackMode;
                preQualDateFrom = p.preQualDateFrom;
                preQualDateTo = p.preQualDateTo;
                createDateFrom = p.createDateFrom;
                createDateTo = p.createDateTo;
                submitDateFrom = p.submitDateFrom;
                submitDateTo = p.submitDateTo;
                approveDateFrom = p.approveDateFrom;
                approveDateTo = p.approveDateTo;
                expirationDateFrom = p.expirationDateFrom;
                expirationDateTo = p.expirationDateTo;
            }
            else {
                certificationStatusCode = params.certificationStatusCode;
                certificationTypeCode = params.certificationTypeCode;
                certificationDaysOpen = params.certificationDaysOpen || null;
                disabledVobStatus = params.disabledVobStatus;
                queueTypeCode = params.queueTypeCode;
                assigneeId = params.assigneeId ? parseInt(params.assigneeId, 10) : null;
                showAll = params.showAll === 'true';
                openOnly = params.openOnly === 'true';
                flagStatusCode = params.flagStatusCode || null;
                preQualDateFrom = params.preQualDateFrom;
                preQualDateTo = params.preQualDateTo;
                createDateFrom = params.createDateFrom;
                createDateTo = params.createDateTo;
                submitDateFrom = params.submitDateFrom;
                submitDateTo = params.submitDateTo;
                approveDateFrom = params.approveDateFrom;
                approveDateTo = params.approveDateTo;
                expirationDateFrom = params.expirationDateFrom;
                expirationDateTo = params.expirationDateTo;
            }
        }

        return {
            form: {
                certificationStatusCode: certificationStatusCode,
                certificationTypeCode: certificationTypeCode,
                certificationDaysOpen: certificationDaysOpen,
                disabledVobStatus: disabledVobStatus,
                vobId: vobId,
                vobName: vobName,
                veteranName: veteranName,
                vobFEIN: vobFEIN,
                queueTypeCode: queueTypeCode,
                certificationNumber: certificationNumber,
                state: state,
                trackMode: trackMode,
                showAll: App.hasPrivilege("AdminShowAllApplications") && (showAll !== null ? showAll : true),
                assigneeId: App.hasPrivilege("AdminShowAllApplications") ? assigneeId : Context.get("userId"),
                openOnly: openOnly,
                flagStatusCode: flagStatusCode,
                preQualDateFrom: preQualDateFrom,
                preQualDateTo: preQualDateTo,
                createDateFrom: createDateFrom,
                createDateTo: createDateTo,
                submitDateFrom: submitDateFrom,
                submitDateTo: submitDateTo,
                approveDateFrom: approveDateFrom,
                approveDateTo: approveDateTo,
                expirationDateFrom: expirationDateFrom,
                expirationDateTo: expirationDateTo
            },
            showAssigReviewerPane: false,
            selectedCertificationId: null,
            showSearchQueueGrid: true,
            showSearchRequestAssociationGrid: false,
			showSearchRequestAppealGrid: false
        }
    }

    componentDidMount() {
        this.search();
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    search = () => {
        if (this.state.form.certificationStatusCode === "RAS") {
            this.setState({ showSearchQueueGrid: false, showSearchRequestAssociationGrid: true, showSearchRequestAppealGrid: false },
                () => { this._searchRequestAssociationGrid.search(this.state.form) });
        }
		else if (this.state.form.certificationStatusCode === "APR") {
			this.setState({ showSearchQueueGrid: false, showSearchRequestAssociationGrid: false, showSearchRequestAppealGrid: true },
                () => { this._searchRequestAppealGrid.search(this.state.form) });
		}
        else {
            this.setState({ showSearchQueueGrid: true, showSearchRequestAssociationGrid: false, showSearchRequestAppealGrid: false },
                () => { this._searchQueueGrid.search(this.state.form, this.handleUnnasignedSearch) });
        }
    }

    // Handlers
    handleSubmit = (e) => {
        e.preventDefault();
        this.search();
    }

    handleReset = (e) => {
        e.preventDefault();
        let pathname = this.props.location.pathname;

        this.props.history.push({
            pathname: pathname
        });

        this._vobFein.setValue("");
        // Reset State
        this.setState(
            this.initialState({
                certificationStatusCode: null,
                certificationTypeCode: null,
                certificationDaysOpen: null
            })
            , function () {
                this.search();
            });
    }

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    handleOpenColSettings = () => {
        this.props.OnOpenColSettings();
    }

    searchVobLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: { type: 'vob' }
        }
    }

    searchVeteranLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: { type: 'vobOwner' }
        }
    }

    handleQueueTypeChange = (e) => {
        var form = this.state.form;

        if (e === null || e.value === null)
            form.certificationStatusCode = null;

        this.setState({ form: form });
    }

    handleCertificationStatusChange = (e) => {
        var form = this.state.form;

        if (e === null || e.value === null || e.value === "APL" || e.value === "RAS")
            form.certificationDaysOpen = null;

        this.setState({ form: form });
    }

    handleReviewerAssigned = () => {
        this.setState({ showAssigReviewerPane: false }, this.search());
    }

    handleUnnasignedSearch = () => {
        this.setState({ certificationStatusCode: this.state.form.certificationStatusCode });
    }

    assignReviewer = (certificationId) => {
        this.setState({ showAssigReviewerPane: true, certificationId: certificationId });
        setTimeout(() => {
            window.scrollTo({
                behavior: "smooth",
                top: this._assignReviewerUser.offsetTop
            });
        }, 1500);
    }

    handleAssignReviewPaneCancel = () => {
        this.setState({ showAssigReviewerPane: false });
    }

    handleAdd = () => {
        var url = `/admin/certification/new`;
        this.props.history.push(url);
    }

    render() {
        return (
            <React.Fragment>
                <ContentHeader title="Search Queue" description=""></ContentHeader>
                <ContentBody>
                    <Form
                        onSubmit={this.handleSubmit}
                        onChange={this.handleChange}
                        onReset={this.handleReset}
                        values={this.state.form}
                        ref={(c) => { this._form = c }}>
                        <Row>
                            <Col md={3} style={{ paddingRight: 5 }}>
                                <Row style={{ marginBottom: 5 }}>
                                    <Col md={5} style={{ paddingRight: 5 }}>
                                        <IntBox
                                            style={{ textAlign: 'left' }}
                                            name='vobId'
                                            positiveOnly
                                            placeholder="App ID"
                                            ref={(c) => { this.focusControl = c }}
                                        />
                                    </Col>
                                    <Col md={7} style={{ paddingLeft: 5 }}>
                                        <TextBox
                                            name="certificationNumber"
                                            placeholder="Certificate Number" />
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: 5 }}>
                                    <Col md={12}>
                                        <SearchBox name="vobName"
                                            placeholder="Company/DBA Name"
                                            loader={this.searchVobLoader} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <MaskedBox
                                            name="vobFEIN"
                                            placeholder="Company FEIN/EIN"
                                            mask="999999999"
                                            alwaysShowMask={false}
                                            ref={(c) => { this._vobFein = c }}
                                            maskChar="" />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <Row style={{ marginBottom: 5 }}>
                                    <Col md={7} style={{ paddingRight: 5 }}>
                                        <SearchBox
                                            name="veteranName"
                                            placeholder="Veteran Name"
                                            loader={this.searchVeteranLoader} />
                                    </Col>
                                    <Col md={5} style={{ paddingLeft: 5, paddingRight: 14 }}>
                                        <CertificationDisabledStatusCombo
                                            name="disabledVobStatus"
                                            clearable />
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: 5 }}>
                                    <Col md={12}>
                                        <CertificationQueueTypeCombo
                                            name="queueTypeCode"
                                            onChange={this.handleQueueTypeChange}
                                            clearable />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <CertificationAssigneeCombo
                                            showAll={this.state.form.showAll}
                                            name="assigneeId"
                                            clearable />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={2} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <Row style={{ marginBottom: 5 }}>
                                    <Col md={12}>
                                        <CertificationTypeCombo
                                            name="certificationTypeCode"
                                            clearable />
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: 5 }}>
                                    <Col md={12}>
                                        <CertificationStatusCombo
                                            name="certificationStatusCode"
                                            queueTypeCode={this.state.form.queueTypeCode}
                                            onChange={this.handleCertificationStatusChange}
                                            clearable />
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: 5 }}>
                                    <Col md={12}>
                                        <CertificationDaysOpenCombo
                                            disabled={
                                                this.state.form.certificationStatusCode === null ||
                                                this.state.form.certificationStatusCode === "APL" ||
                                                this.state.form.certificationStatusCode === "RAS"
                                            }
                                            placeholder="Days In Draft / Submitted"
                                            name="certificationDaysOpen"
                                            clearable />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={4} style={{ paddingLeft: 5 }}>
                                <Row>
                                    <Col md={7} style={{ paddingRight: 5 }}>
                                        <Row style={{ marginBottom: 5 }}>
                                            <Col md={11}>
                                                <CertificationTrackModeCombo
                                                    name="trackMode"
                                                    clearable />
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: 5 }}>
                                            <Col md={11}>
                                                <StateCombo
                                                    name="state"
                                                    placeholder="State Located"
                                                    clearable />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={5}>
                                                <CheckBox style={{ marginTop: 5, marginBottom: 0, marginLeft: 15 }} name="dD214" label="DD214" />
                                            </Col>
                                            <Col md={6}>
                                                {App.hasPrivilege("AdminShowAllApplications") ?
                                                    <CheckBox style={{ marginTop: 5, marginBottom: 0, marginLeft: 5 }} name="showAll" label="Show All" />
                                                    : null}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={5} style={{ paddingLeft: 5 }}>
                                        <Row>
                                            <Col md={12}>
                                                {App.hasPrivilege("AdminAppManagementEdit") ?
                                                    <Button id="btnAddNew" bsStyle="success" className="pull-right" style={{ marginRight: 0 }} onClick={this.handleAdd}>Add new application</Button>
                                                    : null}
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 45 }}>
                                            <Col md={12}>
                                                <div className="pull-right">
                                                    <Button id="btnSearch" type="submit" bsStyle="primary" style={{ marginRight: 5, width: 70 }}>Search</Button>
                                                    <Button id="btnReset" type="reset" bsStyle="default" style={{ marginRight: 0, width: 65 }}>Reset</Button>
                                                    {
                                                        this.props.enableColumnSettings && this.props.setupKey &&
                                                        <Button id="btnSettings" type="button" onClick={this.handleOpenColSettings} bsStyle="default"><Glyphicon glyph="cog" /></Button>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        {/* <Row style={{ marginBottom: 5 }}>
                                            <Col md={12}>
                                                <CheckBox style={{marginTop : 0 }} className="pull-right" name="dd214" label="DD214 Uploaded" />
                                            </Col>
                                        </Row> */}
                                        {/* <Row style={{ marginBottom: 5 }}>
                                            <Col md={12}>
                                                {App.hasPrivilege("AdminShowAllApplications") ?
                                                    <CheckBox style={{marginTop: 0 }} name="showAll" label="Show All" />
                                                : null}
                                            </Col>
                                        </Row> */}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>

                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                        <hr style={{ marginTop: "5px" }} />
                    </Form>
                    {this.state.showSearchQueueGrid &&
                        <SearchQueueGrid
                            ref={(c) => { this._searchQueueGrid = c }}
                            certificationStatusCode={this.state.certificationStatusCode}
                            onAssignReviewer={this.assignReviewer}
                            searchParams={this.state.form}
                            onSearch={this.handleUnnasignedSearch}
                            rowCount={100}
                        />
                    }
                    {this.state.showSearchRequestAssociationGrid &&
                        <SearchRequestAssociationGrid
                            ref={(c) => { this._searchRequestAssociationGrid = c }}
                        />
                    }
					{this.state.showSearchRequestAppealGrid &&
                        <SearchRequestAppealGrid
                            ref={(c) => { this._searchRequestAppealGrid = c }}
                        />
                    }
                    {this.state.showAssigReviewerPane ?
                        <AssignReviewerUser
                            certificationId={this.state.certificationId}
                            certificationQueueTypeCode={this.state.form.queueTypeCode}
                            onReviewerAssigned={this.handleReviewerAssigned}
                            onCancel={this.handleAssignReviewPaneCancel} />
                        : null
                    }
                    <div ref={(c) => { this._assignReviewerUser = c }} ></div>
                </ContentBody>

            </React.Fragment>
        )
    }

}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/Search.js